import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BusinessContact } from '../models/business-contact.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../services/contact.service';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
var EditContactComponent = /** @class */ (function () {
    function EditContactComponent(_matDialogRef, data, _contactService) {
        this._matDialogRef = _matDialogRef;
        this._contactService = _contactService;
        this.isNew = false;
        this.isLoading = false;
        this.contact = data.contact || new BusinessContact();
        this.isNew = data.isNew || false;
        this.businessID = data.busID;
        this.originalContact = Object.assign(new BusinessContact(), data.contact);
        this.itemsToChange = new Set();
        if (this.isNew) {
            this.contact.okToPublish = true;
        }
    }
    EditContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            okToPublish: new FormControl(''),
            titleDept: new FormControl('', [Validators.required, Validators.maxLength(50)]),
            name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
            email: new FormControl('', [Validators.maxLength(50), Validators.pattern('.+\\@.+\\..+')]),
            phone: new FormControl(formatPhoneString(this.contact.phone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditContactComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.contact.phone = undoPhoneFormat(this.formGroup.get('phone').value);
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._contactService.postBusinessContact(this.businessID, this.contact)];
                    case 1:
                        res = _a.sent();
                        this.contact = BusinessContact.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._contactService.putBusinessContact(this.businessID, this.contact)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.contact, BusinessContact.parse(res));
                        this.contact = BusinessContact.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, contact: this.contact });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * formats passed in phone number string and saves to appropriate form field.
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditContactComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    EditContactComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone or fax field goes out of focus
     * @param {string} field
     */
    EditContactComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    /**
     * triggered by cancel button click event
     */
    EditContactComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditContactComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.contact, this.originalContact);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditContactComponent;
}());
export { EditContactComponent };
